import wixLocation from 'wix-location';

/**
 * @param {string} keyword
 * @param {Industry} industry
 */
export function goToNextPage(keyword, industry = null) {
    if (keyword) {
        const queryParams = new URLSearchParams({
            businessIdea: keyword,
        })
        if (industry) {
            queryParams.append('industry', industry.value);
        }
        wixLocation.to(`/names-list?${queryParams.toString()}`)
    }
}

export function fetchUserId() {
    return fetch('https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails', {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'include',
        cache: 'no-store'
    }).then(httpResponse => httpResponse.json()).catch(e => e);
}

/**
 * @typedef {Object} Industry
 * @property {string} value
 * @property {string} industryId
 * @property {string} structureId
 * @property {string} postRegVertical 
 */

